(function () {
  'use strict';

  function initClubFeature(root) {
    if (!root || root.dataset.hbcClubInitialised) return;
    root.dataset.hbcClubInitialised = 'true';

    var revealItems = Array.from(root.querySelectorAll('[data-hbc-club-reveal]'));
    var image = root.querySelector('[data-hbc-club-image] .hbc-club__image');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer = window.matchMedia('(pointer: fine)').matches;

    revealItems.forEach(function (item, index) {
      item.style.setProperty('--hbc-club-delay', Math.min(index * 90, 360) + 'ms');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revealItems.forEach(function (item) { item.classList.add('is-visible'); });
        observer.disconnect();
      });
    }, { threshold: 0.18 });

    observer.observe(root);

    if (image && finePointer) {
      var ticking = false;

      function updateImage() {
        ticking = false;
        var rect = root.getBoundingClientRect();
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        var progress = Math.max(0, Math.min(1, (viewport - rect.top) / (viewport + rect.height)));
        image.style.setProperty('--hbc-club-image-y', (-8 + progress * 6).toFixed(2) + '%');
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateImage);
      }

      updateImage();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  function initWithin(scope) {
    var sections = [];
    if (scope.matches && scope.matches('[data-hbc-club]')) sections.push(scope);
    sections = sections.concat(Array.from(scope.querySelectorAll('[data-hbc-club]')));
    sections.forEach(initClubFeature);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initWithin(document); });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });
})();